import { render, staticRenderFns, recyclableRender, components } from "./auth-login.vue?vue&type=template&id=c3342d78&scoped=true&"
var renderjs
import script from "./auth-login.vue?vue&type=script&lang=js&"
export * from "./auth-login.vue?vue&type=script&lang=js&"
import style0 from "./auth-login.vue?vue&type=style&index=0&id=c3342d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3342d78",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/auth-login/auth-login.vue"
export default component.exports